export default __webpack_public_path__ + "static/media/greenpeople.90a901a7.png";